import React from 'react';
import { pricingData } from '../content';
import PaymentSection from '../components/pricing/PaymentSection';
import BankAccountInfo from '../components/pricing/BankAccountInfo';
import TuitionInfo from '../components/pricing/TuitionInfo';
import LunchInfo from '../components/pricing/LunchInfo';
import ExtraActivitiesList from '../components/pricing/ExtraActivitiesList';

const PricingPage = () => {
  return (
    <div className="container">
      <h1>Ceník</h1>
      
      <div className="pricing-info">
        <h2>Informace o platbách</h2>
        
        <PaymentSection title="Bankovní spojení">
          <BankAccountInfo 
            number={pricingData.bankAccount.number} 
            bank={pricingData.bankAccount.bank} 
          />
        </PaymentSection>
        
        <PaymentSection title="Příspěvek na vzdělávací aktivity komunitního centra">
          <TuitionInfo
            monthly={pricingData.tuition.monthly}
            period={pricingData.tuition.period}
            description={pricingData.tuition.description}
          />
        </PaymentSection>

        <PaymentSection title="Obědy">
          <LunchInfo
            provider={pricingData.lunch.provider}
            price={pricingData.lunch.price}
            paymentMethod={pricingData.lunch.paymentMethod}
            ordering={pricingData.lunch.ordering}
            cancellation={pricingData.lunch.cancellation}
          />
        </PaymentSection>

        {pricingData.extraActivities && pricingData.extraActivities.length > 0 && (
          <PaymentSection title="Mimoškolní aktivity">
            <ExtraActivitiesList activities={pricingData.extraActivities} />
          </PaymentSection>
        )}
        
        <div className="payment-info">
          <h3>Způsob platby</h3>
          <p>{pricingData.paymentInfo}</p>
        </div>
      </div>
    </div>
  );
};

export default PricingPage; 